export const sendBookConsultation = (data) => (
  $.ajax({
    type: 'POST',
    url: "/book-consultation",
    data: data
  })
);

export const sendBookConsultationDiscount = (data, captcha) => (
  $.ajax({
    type: 'POST',
    url: "/book-consultation/send_discount",
    data: {...data, captcha}
  })
);

export const sendBookConsultationCallback = (data, captcha) => (
  $.ajax({
    type: 'POST',
    url: "/book-consultation/send_callback",
    data: { ...data, captcha }
  })
);

export const sendFreeGuide = (data, captcha) => (
  $.ajax({
    type: 'POST',
    url: "/book-consultation/send_free_guide",
    data: { ...data, captcha }
  })
);

export const sendFirstShootOffer = (data, captcha) => (
  $.ajax({
    type: 'POST',
    url: "/book-consultation/send_first_shoot_offer",
    data: { ...data, captcha }
  })
);

export const sendPhotographyAudit = (data) => (
  $.ajax({
    type: 'POST',
    url: "/book-consultation/send_photography_audit",
    data: data
  })
);